import React, { useState } from 'react'
import serializeObject from '@arsenal/arsenal/modules/serializeObject'
import QRCode from 'qrcode.react'
import Dialog from 'Components/dialog'
import Toast from 'Components/toast-messager'
import { stopPropagation } from 'Components/new/community-card/interact'
import dialogStyle from 'Components/dialog.module.scss'

function shareQQ({ url, title, pic }: IProps) {
  window.open(
    `https://connect.qq.com/widget/shareqq/iframe_index.html?${serializeObject({
      url,
      title,
      pics: pic,
    })}`,
    '_blank'
  )
}

function shareQQZone({ url, title, pic }: IProps) {
  window.open(
    `http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?${serializeObject(
      {
        url,
        title,
        pics: pic,
      }
    )}`,
    '_blank'
  )
}

function shareXLWB({ url, title, pic }: IProps) {
  window.open(
    `https://service.weibo.com/share/share.php?${serializeObject({
      url,
      title,
      pic,
    })}`,
    '_blank'
  )
}

function autoCopyValue(value = ''): boolean {
  const input = document.createElement('input')
  document.body.appendChild(input)
  input.style.cssText = 'opacity:0;position:fixed;left:0;top:0;'
  input.value = value
  input.focus()
  input.setSelectionRange(0, input.value.length)
  const res = document.execCommand('copy', false)
  document.body.removeChild(input)
  return res
}

interface IProps {
  url?: string // 参数url设置分享的内容链接|默认当前页location
  title?: string // 参数desc设置分享的描述，可选参数
  pic?: string // 参数pics设置分享图片的路径，多张图片以＂|＂隔开，可选参数
  onCopySuccess?(): void
  onShare?(text: string): void
}

const Share: React.FC<IProps> = (props) => {
  const { url, onCopySuccess, onShare } = props

  const [qrcodeVisible, setQrcodeVisible] = useState(false)

  return (
    <React.Fragment>
      <div
        className="tw-px-12 tw-py-20 tw-text-12 tw-text-common-gray"
        onClick={stopPropagation()}
      >
        <div className="tw-flex tw-justify-around tw-text-center">
          <span
            className="item tw-w-36 tw-pt-40 tw-cursor-pointer hover:tw-text-common-black"
            onClick={() => {
              setQrcodeVisible(true)
              if (onShare) onShare('微信')
            }}
          >
            微信
          </span>
          <span
            className="item tw-w-36 tw-pt-40 tw-cursor-pointer hover:tw-text-common-black"
            onClick={() => {
              shareXLWB(props)
              if (onShare) onShare('微博')
            }}
          >
            微博
          </span>
          <span
            className="item tw-w-36 tw-pt-40 tw-cursor-pointer hover:tw-text-common-black tw-inline-flex tw-justify-center tw-whitespace-nowrap"
            onClick={() => {
              shareQQZone(props)
              if (onShare) onShare('QQ空间')
            }}
          >
            QQ空间
          </span>
          <span
            className="item tw-w-36 tw-pt-40 tw-cursor-pointer hover:tw-text-common-black"
            onClick={() => {
              shareQQ(props)
              if (onShare) onShare('QQ')
            }}
          >
            QQ
          </span>
        </div>
        <div className="tw-mt-16 tw-text-12 tw-flex tw-h-24 tw-leading-24 tw-w-230 tw-select-none">
          <div className="tw-flex-1 tw-border-1 tw-border-solid tw-border-video-shallow-gray tw-border-r-0 tw-px-8 line-1">
            {url}
          </div>
          <button
            type="button"
            className="tw-w-64 tw-bg-black tw-text-white"
            onClick={() => {
              if (autoCopyValue(url)) {
                Toast.show({
                  text: '复制成功',
                })
                if (onCopySuccess) onCopySuccess()
                if (onShare) onShare('复制地址')
              }
            }}
          >
            复制地址
          </button>
        </div>
      </div>
      <Dialog
        visible={qrcodeVisible}
        onClose={() => setQrcodeVisible(false)}
        className={dialogStyle['space-small']}
        headerClass={dialogStyle['space-small']}
        closeText={'关闭'}
      >
        <div className="tw-p-24 tw-bg-white tw-text-common-black tw-text-18 tw-font-medium">
          微信扫码分享到微信好友 或 朋友圈
          <QRCode
            className="tw-mt-16 tw-mx-auto"
            value={url || ''}
            size={280}
          />
        </div>
      </Dialog>
      <style jsx>
        {`
          .item:nth-child(1) {
            background: url(${require('static/logo-weixin@2x.png')}) center
              top/36px 36px no-repeat;
          }
          .item:nth-child(2) {
            background: url(${require('static/logo-xlwb.svg')}) center top/36px
              36px no-repeat;
          }
          .item:nth-child(3) {
            background: url(${require('static/logo-qqzone.svg')}) center
              top/36px 36px no-repeat;
          }
          .item:nth-child(4) {
            background: url(${require('static/logo-qq@2x.png')}) center top/36px
              36px no-repeat;
          }
          .item {
            position: relative;
          }
          .item:hover:before {
            content: none;
          }
          .item:before {
            content: '';
            position: absolute;
            top: 0;
            left: 50%;
            width: 36px;
            height: 36px;
            transform: translateX(-50%);
            background: rgba(255, 255, 255, 0.2);
          }
        `}
      </style>
    </React.Fragment>
  )
}

export default Share
